<script>
export default {
    name:'Popup',
    props:[
        'showDialog',
        'cancel',
        'confirm',
        'cnacelTxt',
        'confirmTxt',        
    ]
}
</script>

<template src="./template.html"></template>
<style src="./style.css"></style>